import {useAppSelector} from "../../../redux/hooks";
import {
  getUserLibraryFavoritedSongCardResults as getMySongsLibraryUserLibraryFavoritedSongCardResults,
  getUserLibrarySongCardResults as getMySongsLibraryUserLibrarySongCardResults,
  ISongArrangementCardWithProgress
} from "../../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.selector";
import { useParams } from "react-router-dom";
import {mySongsLibraryStore} from "../../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.store";

export interface ISongsResultsLibraryLogic {
  totalSongs: number;
  totalFilteredSongs: number;
  filteredLessons: ISongArrangementCardWithProgress[];
}

const filteredLessonsSelectorFactory = (libraryFilterSubset?: 'favorites'| string) => {
  if (libraryFilterSubset === "favorites") {
    return getMySongsLibraryUserLibraryFavoritedSongCardResults;
  }

  return getMySongsLibraryUserLibrarySongCardResults;
}

export const useSongsResultsLibraryLogic = (): ISongsResultsLibraryLogic => {
  const {libraryFilterSubset} = useParams();
  const totalSongs = useAppSelector(mySongsLibraryStore.getUserLibrary).length;
  const filteredLessons = useAppSelector(filteredLessonsSelectorFactory(libraryFilterSubset));
  const totalFilteredSongs = filteredLessons.length;

  return {
    totalSongs,
    totalFilteredSongs,
    filteredLessons,
  };
}
